import { render, staticRenderFns } from "./UnoccupiedAndRealesae.vue?vue&type=template&id=9bfa3434&scoped=true&"
import script from "./UnoccupiedAndRealesae.vue?vue&type=script&lang=js&"
export * from "./UnoccupiedAndRealesae.vue?vue&type=script&lang=js&"
import style0 from "./UnoccupiedAndRealesae.vue?vue&type=style&index=0&id=9bfa3434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfa3434",
  null
  
)

export default component.exports